
import {
  computed, defineComponent, PropType, ref, SetupContext,
} from 'vue';
import { useI18n } from 'vue-i18n';
import ChooseItemsModal from '@/components/modals/ChooseItemsModal.vue';
import {
  SpmTableFilter, StringMap,
} from '@/types';

export default defineComponent({
  name: 'BaseItemList',

  components: {
    ChooseItemsModal,
  },

  props: {
    modelValue: {
      type: Array as PropType<StringMap[]>,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    buttonLabel: {
      type: String,
      required: true,
    },

    name: {
      type: String,
      required: true,
    },

    fields: {
      type: Object as PropType<StringMap>,
      required: true,
    },

    items: {
      type: String,
      required: false,
      default: '',
    },

    format: {
      type: Function,
      required: false,
      default: (value: StringMap) => value,
    },

    defaultFilters: {
      type: Array as PropType<SpmTableFilter[]>,
      required: false,
      default: () => [],
    },

    enableVariants: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  emits: ['update:modelValue'],

  setup(props: { format: Function; items: string }, { emit }: SetupContext) {
    const { t } = useI18n();
    const displayModal = ref(false);
    const onChooseItems = (items: StringMap[]) => emit('update:modelValue', [...items.map((item: StringMap) => props.format(item))]);
    const selectedCount = computed(() => {
      if (!props.items || props.items.trim() === '') return 0;
      return props.items
        .split(',')
        .map((token) => token.trim())
        .filter((token) => token !== '')
        .reduce((count, token) => {
          const bracketMatch = token.match(/\[([0-9;]+)\]$/);
          if (bracketMatch) {
            return count + bracketMatch[1].split(';').filter((id) => id !== '').length;
          }
          return count + 1;
        }, 0);
    });

    return {
      t,
      displayModal,
      onChooseItems,
      selectedCount,
    };
  },

});
